export default __webpack_public_path__ + "static/media/update-curves.99361e87.svg";